module.exports = __webpack_public_path__ + "static/media/Minerva McGonagall 3.d71e478e.jpg";